export default "__VITE_ASSET__BhMgwUQ1__"